import { getApi, postApi } from '@utils/request';

const shootInfoApi = {
  optionSearch: (params) => postApi('/script/brief/answer/option/search', params), // brief搜索答案选项
  question: (params) => postApi('/script/brief/question', params), // 获取brief问题信息
  optionAdd: (params) => postApi('/script/brief/answer/option/add', params), // 获取brief问题信息
  confirmBrief: (params) => postApi('/trade/suborder/confirm-brief', params), // 提交信息
  openShared: (params) => postApi('/trade/serviceorder/open-shared', params), // 同意服务单分享
  sharedDetail: (params) => postApi('/trade/serviceorder/shared-detail', params), // 分享页面进去调这个详情
  onepicTake: () => postApi('/trade/config/subscribe/remind/onepic-take') // 预约须知一张图
};
export default shootInfoApi;
